class CartItemRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.closest('cart-form').updateQuantity(this.dataset.cartItem, 0);
    });
  }
}

customElements.define('cart-item-remove', CartItemRemove);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.debounce((event) => {
      this.fetchConfig = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }};
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      this.fetchConfig.body = JSON.stringify({ note: event.target.value });

      fetch(`${routes.cart_update_url}`, this.fetchConfig);
    }, 300))
  }

  debounce(fn, wait) {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait) };
  }
}

customElements.define('cart-note', CartNote);

class CartForm extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.generalErrorElement = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = this.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  debounce(fn, wait) {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait) };
  }

  onChange(event) {
    if (!event.target.closest('[data-cart-item]')) return;

    this.cartItem = event.target.closest('[data-cart-item]').dataset.cartItem;
    this.updateQuantity(this.cartItem, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-form',
        section: this.dataset.id,
        selector: '#cart-item-list'
      },
      {
        id: 'cart-form',
        section: this.dataset.id,
        selector: '#cart-live-region-text'
      },
      {
        id: 'cart-form',
        section: this.dataset.id,
        selector: '#cart-total-price'
      },
      {
        id: 'header',
        section: 'header',
        selector: 'cart-icon'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.generalErrorElement.classList.add('hidden');

    this.fetchConfig = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }};
    this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
    this.fetchConfig.body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, this.fetchConfig)
    .then((response) => { return response.text() })
    .then((response) => {
      response = JSON.parse(response);

      this.classList.toggle('cart-empty', response.item_count === 0);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { response } }));

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.querySelector(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
      }));

      this.querySelector(`[data-cart-item="${line}"]`)?.querySelector(`[name="${name}"]`)?.focus();
      this.updateLiveRegions(line, response.item_count);
      this.disableLoading();
    }).catch(() => {
      this.generalErrorElement.classList.remove('hidden');
      this.disableLoading();
    });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      this.querySelector(`[data-cart-item="${line}"`).querySelector('.cart-error').classList.remove('hidden');
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => { cartStatus.setAttribute('aria-hidden', true) }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    this.classList.add('cart-loading');
    document.documentElement.classList.add('document-loading');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.remove('cart-loading');
    document.documentElement.classList.remove('document-loading');
  }
}

customElements.define('cart-form', CartForm);
